import { get } from "./AwsRequestService"

const myApi = 'FlightService'

export async function getRouteMarketShare(dep, arr, date) {
    const getPath = `/api/routes/marketshare/dep/${dep}/arr/${arr}/date/${date}`
    return await get(myApi, getPath);
}